export function getTimeString(value = 0) {
  const seconds = parseInt(value, 10) || 0;
  if (seconds < 10) {
    return `0:0${seconds}`;
  }
  return `0:${seconds}`;
}
